/**
 * Asterisk
 */

import React from 'react';
import css from './Asterisk.css';

const Asterisk = () => (
  <span className={css.asterisk} aria-hidden>
    *
  </span>
);

export default Asterisk;
